import { render, staticRenderFns } from "./alfx.vue?vue&type=template&id=51d24e4a&scoped=true"
import script from "./alfx.vue?vue&type=script&lang=js"
export * from "./alfx.vue?vue&type=script&lang=js"
import style0 from "./alfx.vue?vue&type=style&index=0&id=51d24e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d24e4a",
  null
  
)

export default component.exports